// extracted by mini-css-extract-plugin
export default {"productcomp":"ProductComp_productcomp__GwokO","filtercomp":"ProductComp_filtercomp__ffxCL","productlist":"ProductComp_productlist__rLdFo"};